module.exports = __webpack_public_path__ + "static/media/avatar.e147bdeb.png";